<template>
  <div class="salesmanfenliustorePage">
    <div class="xr-mingxi">        
        <mu-appbar class="xr-head" title="分流创客">
            <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
            <router-link  slot="right" to="/salesman/fenliuStream">
                <p >明细</p>
            </router-link>
        </mu-appbar>
    </div>
        <div class="gd-content">
            <h5>可分流<span>{{fenliuInfo.NowCount}}</span>分流套餐</h5>
           
            <div class="gt-form">
                <mu-row gutter>
                   <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
                       <mu-text-field label="用户名/手机号" type="text" helpText=""  labelFloat fullWidth v-model="UserNames" />
                   </mu-col>
                </mu-row>
            </div>
            <mu-row class="gutter">
            <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
            <mu-raised-button label="分流" class="submit" primary fullWidth @click="submit()" />
            </mu-col>
            </mu-row>
            <p class="desc">注：</p>
            <p class="desc">1、只能分流已经注册的商城会员。2、一个分流套餐等于一个创客套餐。</p>
        </div>
        
        <XR-toast ref="XRtoast"></XR-toast>
    </div>
</template>
<script>
export default {
    data(){
        return {
            UserNames: this.$route.query.userNames,
            fenliuInfo:{
                NowCount:0
            }
        }
    },
    mounted(){
        this.getInfo()
    },
    methods:{     
        GoHistory(){
            this.$router.goBack()
        },
        getInfo(){            
            var ths = this;  
            
            ths.$post(
                "/Salesman/SalesmanServer/GetFenLiuTotalByMinnerBm",{SalesmanType:1}
            ).then(function(res) {
                if(!res.IsSuccess){

                }else{
                    ths.fenliuInfo = res.Data
                }
            });
        },        
        submit: function(){
            var ths = this;  
            
            if(!this.UserNames){
                ths.$refs.XRtoast.failed('请输入用户名', true)
                return
            }
            var usernameList = this.UserNames.split(',')
            
            ths.$post(
                "/Salesman/SalesmanServer/FenLiu",{SalesmanType:1, UserNameList: usernameList}
            ).then(function(res) {
                if(!res.IsSuccess){
                    ths.$refs.XRtoast.failed(res.Msg, true)
                }else{
                    ths.$refs.XRtoast.successCallback(res.Msg, function(){
                        ths.$router.push('/salesman/mymemberviplist')
                    })
                }
            });
        },
    }
}
</script>

<style>
  body .salesmanfenliustorePage{
      background: #fff;
    }
     .salesmanfenliustorePage .gd-content h5
        {   
            height: 47px;
            padding:20px 0;
            font-size:12px;
            font-weight:400;
            text-align:center;    
        }
    .salesmanfenliustorePage  .gd-content h5 span{
            color:red;
        }
   .salesmanfenliustorePage .gt-form .row{
        padding: 0px 5%;
    }
   .salesmanfenliustorePage  div .reg-prompt
    {   
        height: 37px;
        color:#999;
        text-align:right;
        font-size:13px;
        padding-right:5%;
        padding-bottom:10px;
    }      
    .salesmanfenliustorePage .mu-text-field-content{
        padding: 0px ;
    }
    .salesmanfenliustorePage .btn{
        text-align: center;
    }
    .salesmanfenliustorePage .mu-raised-button{
        width: 100%;
    }
     .salesmanfenliustorePage p.desc {
        line-height: 20px;
        font-size: .75rem;
        color: #666;
        margin-bottom: .2rem;
        padding: 0 5%;
    }
    .salesmanfenliustorePage .salesmanfenliustore{
        background: white;
    }
   .salesmanfenliustorePage .forgetBtn {
        float: right;
        }       

   .salesmanfenliustorePage .btn-div {
        padding: 40px 5% 30px;
    }
    .salesmanfenliustorePage .submit {
         height: 50px;
    }
    .salesmanfenliustorePage .xr-mingxi .mu-appbar.fixed{  
        padding:0;
        position: fixed;
        top:0;
        left: 0;
        }
    .salesmanfenliustorePage .xr-mingxi .mu-appbar-title {
        font-size: 16px;
        }
    .salesmanfenliustorePage .xr-mingxi .title .mu-icon-button {
        position: absolute;
        left: 0;
        top: 0;
        color:white;
        }
    .salesmanfenliustorePage .xr-mingxi .title .title-text {
        margin: 0;
        line-height: 48px;
        }
    .salesmanfenliustorePage .xr-mingxi .right{
        margin: 0 8px;
        font-size: 16px
    }
    .salesmanfenliustorePage .xr-mingxi .right a{
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/fenliustore.vue